import React from 'react';
import { Icons } from '../Icons';
export const searchIcon = React.createElement(Icons, { iconName: "ic-ui-search", className: "ic-ui-search" });
export const chevronIcon = React.createElement(Icons, { iconName: "ic-ui-chevron-down", className: "ic-ui-chevron-down" });
export const crossIcon = React.createElement(Icons, { iconName: "ic-ui-cancel-sm" });
export const tickIcon = React.createElement(Icons, { iconName: "ic-ui-tick-01" });
//# sourceMappingURL=icons.js.map